module.exports = __webpack_public_path__ + "img/SL-M-220-280.d29f12f1.svg";